import { getFields, processEntity } from 'context/fields';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import { EntityType } from 'shared/constants/entityTypes';
import { safeJsonParse } from 'shared/utils/functions';
import { isPanelType } from 'shared/utils/misc';

const strategies = {
  merge: {},
  process: {
    [EntityType.ORDER]: (entity) => {
      return {
        _qbDataType: EntityType.ORDER,
        ...entity,
      };
    },

    [EntityType.SAMPLE]: (entity, parent, key) => {
      return {
        _qbDataType: EntityType.SAMPLE,
        ...entity,
      };
    },

    [EntityType.TEST]: (entity) => {
      return omit(
        {
          _qbDataType: EntityType.TEST,
          ...entity,
          status: {
            value: entity.state || null,
            label: entity.state || '',
          },
        },
        ['state']
      );
    },

    [EntityType.ASSAY]: (entity) => {
      if (isPanelType(entity)) return entity;

      const entityType = EntityType.TEST;
      const testFields = getFields({ entityType });
      const { default_to_test_config: configJson, ...assay } = entity;
      const defaultToTestObj = isEmpty(configJson)
        ? {}
        : processEntity({ entity: safeJsonParse(configJson), entityType });
      const _defaultToTestFields = testFields.map((field) => ({
        ...field,
        portalDefaultValue:
          defaultToTestObj[field.name] || field.portalDefaultValue,
      }));

      return {
        ...assay,
        _defaultToTestFields,
      };
    },
  },
  fallback: {},
};

export default strategies;
